<template>
  <section>
    <div class="row">
      <div class="col-lg-12">
        <PageTitle :title="title" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/restaurants',title: crumb}]" />
        <br/>
        <div class="tabs-container">
          <ul class="nav nav-tabs nav-justified margin-horizontal-15">
            <li class="active nav_custom_class text-center"><a data-toggle="tab" href="#restaurants" @click="updateTitle('All Restaurants', 'Restaurants')">Restaurants</a></li>
            <li class="nav_custom_class text-center"><a data-toggle="tab" href="#areas" @click="updateTitle('All Areas', 'Areas')">Areas</a></li>
            <li class="nav_custom_class text-center"><a data-toggle="tab" href="#exclusive-deals" @click="updateTitle('All Marketplace Exclusive Deals', 'Marketplace Exclusive Deals')">Marketplace Exclusive Deals</a></li>
            <li class="nav_custom_class text-center"><a data-toggle="tab" href="#live-status-of-branches" @click="updateTitle('Live Statuses', 'Live Statuses')">Live Statuses of Branches</a></li>
          </ul>
          <div class="tab-content">
            <div id="restaurants" class="tab-pane active">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12">
                    <Restaurants />
                  </div>
                </div>
              </div>
            </div>
            <div id="areas" class="tab-pane">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12">
                    <Areas :hidePageTitle="true"/>
                  </div>
                </div>
              </div>
            </div>
            <div id="exclusive-deals" class="tab-pane">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12">
                    <BaykedExclusiveDeals :hidePageTitle="true"/>
                  </div>
                </div>
              </div>
            </div>
            <div id="live-status-of-branches" class="tab-pane">
              <div class="panel-body">
                <LiveStatusofBranches :hidePageTitle="true"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitle from '@/components/layout_components/PageTitle'
import Restaurants from "@/views/Restaurants.vue";
import Areas from "@/views/Areas.vue";
import BaykedExclusiveDeals from "@/views/BaykedExclusiveDeals.vue";
import LiveStatusofBranches from "@/views/LiveStatusofBranches.vue";
import restaurants from "@/views/Restaurants.vue";

export default {
  name: "RestaurantTabView",
  computed: {
    restaurants() {
      return restaurants
    }
  },
  components: {
    LiveStatusofBranches,
    PageTitle,
    Restaurants,
    Areas,
    BaykedExclusiveDeals
  },
  data() {
    return {
      title: 'All Restaurants',
      crumb: 'restaurants',
    }
  },
  methods: {
    updateTitle (title, crumb) {
      this.title = title,
      this.crumb = crumb
    }
  }
}
</script>

<style scoped>
.nav_custom_class{
  width: 25% !important;
}
</style>